import JuiceProduct from './JuiceProduct'
import ProductDescription from './ProductDescription'

const BottledJuiceProduct = {
  ...ProductDescription,
  category: '54',
  subCategory: '002',
  JuiceType: 'Bottled',
  ...JuiceProduct,
}

export default BottledJuiceProduct
